export const defaultFilter = () => {
    return {
        description: null,
        state: 'all',
        page: 1,
        per_page: 10,
    }
}

export const defaultPayloadForm = () => {
    return {
        id: null,
        description: null,
        components_ids: [],
    }
}

export default {
    filter: defaultFilter(),
    payloadForm: defaultPayloadForm(),
    casFamilies: { data: [], total: 0},
    showModalForm: false,
    listFamilies: [],
    showModalComponents: false,
    showModalChangeStatus: false,

}
